import feathers from '@feathersjs/feathers';
import rest from '@feathersjs/rest-client';
var client = feathers();
var restClient = rest('https://api.mcgmedia.net/');
client.configure(restClient.fetch(window.fetch));
export default client;